import React from 'react'

import cm from './Skeleton.module.css'

interface IProps {
  /** The width of the image skeleton */
  width?: number
  /** The height of the image skeleton */
  height?: number
  /** The className to apply to the image skeleton */
  className?: string
  'data-test-id'?: string
}

const SkeletonImage = ({ width, height, className = '', 'data-test-id': dataTestId }: IProps) => (
  <div
    className={`${cm.skeleton} ${className}`}
    style={{ width, height }}
    data-test-id={dataTestId}
  />
)

export default SkeletonImage
